import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import VlmCare from "@/pages/VlmCare";

export const Route = createFileRoute("/en/services/software-solutions-services/vlmcare")({
  head: () => buildRouteHead("/en/services/software-solutions-services/vlmcare"),
  component: VlmCare,
});

